export interface ContentSuggestionModel {
  appId: string;
  language : string;
}
